/*************************************************
 * VirtuOwl
 * SocketActions.js
 * Copyright © 2018 concertIDC. All rights reserved.
 *************************************************/
import { myLog } from '../../utils/Utility';
import URL from '../../utils/URL';
import { PATH, ACTION_TYPES } from '../../utils/Constants';
import soundFile from '../../utils/assets/notify.wav';
import messageSoundFile from '../../utils/assets/message_notify.mp3';
import { Manager } from 'socket.io-client';

import store from '../../sessionStorage';
import stores from '../../stores';
import {
    NAMESPACE_WEB,
    CONNECTE,
    DISCONNECTED,
    SOCKET_CONNECTED,
    VIDEO_CALL_CONNECTED,
    ENDED_CALL,
    SOCKET_DISCONNECTED,
    CONNECT_TIMEOUT,
    WRONG_INFORMATION,
    PATIENT_CALL_END,
    CONNECT_ERROR,
    ON_MESSAGE,
    PATIENT_BUSY,
    PATIENT_CONNECTED,
    PATIENT_DISCONNECTION,
    EMIT_ON_DOCTOR_CONNECT,
    EMIT_ON_SEND_MESSAGE,
    PATIENT_CALL_INITIATION,
    VIDEO_CONSULTATION_REJOIN,
    VIDEO_CONSULTATION_LEFT,
    NAMESPACE_CHAT,
    DOCTOR_BUSY,
    DOCTOR_CONNECTED,
    DOCTOR_DISCONNECTION,
    EMIT_ON_CLASSROOM_CONNECT,
    DOCTOR_END_CALL,
    ON_PHYSICIAN_CAMERA_OFF,
    ON_PHYSICIAN_CAMERA_ON,
    PHYSICIAN_CAMERA_ON,
    PHYSICIAN_CAMERA_OFF,
    ON_PATIENT_CALL_END,
    NEW_ONDEMAND_BOOKED,
    NEW_APPOINTMENT_BOOKED,
    NOTIFICATION_COUNT,
    INACTIVE_USER,
    LIVE_STREAM_STARTED,
    STUDENT_PARTICIPATION_LIST,
    EDUCATOR_MUTE_MESSAGE,
    EMIT_ON_CUSTOM_SEND_MESSAGE,
    ON_CHAT_MESSAGE,
    NAMESPACE_CUSTOM_CHAT,
    ON_CHAT_MESSAGE_READ,
    UN_UNREAD_COUNT,
    ON_TYPING,
    ON_WHITEBOARD_MESSAGE,
    EMIT_ON__WHITEBOARD_SEND_MESSAGE,
    EMIT_ON__WHITEBOARD_OPEN,
    WHITEBOARD_OPEN_MESSAGE,
    ANONYMOUS_USER_DISCONNECTION,
    ANONYMOUS_USER_CONNECTED,
    ON_CHAT_OPENED,
    MEETING_SUMMARY,
    NEW_SESSION_DETAILS,
    EMIT_STREAM_ID_CREATED,
    EMIT_LIVE_CAPTION,
    ON_STREAM_ID_CREATED,
    ON_LIVE_CAPTION,
} from '../../utils/SocketConstants';

import {
    BroadCastSession,
    ClassroomSession,
    //Consumer,
    Doctor,
    OnDemand,
    Patient,
    Scheduled,
    Tutor,
    // waitingRoom,
    Collaborator,
    waitingRooms,
    ConferenceCall,
    Anonymous,
} from '../../utils/common/NamingTerms';
import localStorage from '../../localStorage';
import { userSessionTimer, userTokenRenewalTimer } from '../../utils/AthuService';
import { socketServerDownProblem } from './NetworkAction';
import { RESPONSE_CONSTANT } from '../../utils/ResponseConstant';
import AppConfig from '../../utils/common/DomainConfiguration';
import { getTranslation } from '../../utils/common/LanguageContext';
import {
    clearWhiteboardDataForSession,
    pruneWhiteboardSessionsExcept,
    saveWhiteboardDataForSession,
    setActiveWhiteboardSession,
} from '../../utils/WhiteboardSessionStorage';

let socketWeb;
let socketChat;
let socketCustomChat;
let isAppConnect = false;
let isChatConnect = false;
const audio = new Audio(soundFile);

const MESSAGE_READ = 'on_message_read';
const MEETING_SUMMARY_EVENT = 'meeting-summary-received';
const VONAGE_SESSION_DETAILS = 'vonage_session_details';

const setMeetingSummaryPendingForSession = (visitId) => {
    const normalizedVisitId = String(visitId || '');
    const existingVisitId = window.sessionStorage.getItem('LAST_VISITED_SESSION_ID') || '';
    const existingPendingAtRaw = window.sessionStorage.getItem('MEETING_SUMMARY_PENDING_AT');
    const existingPendingAt = Number(existingPendingAtRaw);
    const shouldResetPendingAt =
        existingVisitId !== normalizedVisitId || !Number.isFinite(existingPendingAt);

    window.sessionStorage.setItem('LAST_VISITED_SESSION_ID', normalizedVisitId);
    window.sessionStorage.setItem('MEETING_SUMMARY_PENDING', 'true');
    if (shouldResetPendingAt) {
        window.sessionStorage.setItem('MEETING_SUMMARY_PENDING_AT', String(Date.now()));
    }
};

const emitMeetingSummaryEvent = (payload) => {
    if (typeof window !== 'undefined' && window.dispatchEvent) {
        window.dispatchEvent(
            new CustomEvent(MEETING_SUMMARY_EVENT, {
                detail: payload,
            })
        );
    }
};

// Centralized, structured console logging for video/chat events
const logSessionEvent = (level, message, context = {}) => {
    const logPayload = {
        scope: 'VideoSession',
        message,
        level,
        timestamp: new Date().toISOString(),
        ...context,
    };

    if (level === 'error') {
        // eslint-disable-next-line no-console
        console.error('[VideoSession]', logPayload);
    } else if (level === 'warn') {
        // eslint-disable-next-line no-console
        console.warn('[VideoSession]', logPayload);
    } else {
        // eslint-disable-next-line no-console
        console.info('[VideoSession]', logPayload);
    }
};

const normalizeVonageSessionPayload = (data = {}) => {
    const apikey = data.apikey || data.apiKey || data?.activeSession?.apikey || '';
    const opentokSession =
        data.opentokSession || data.sessionId || data?.activeSession?.opentokSession || '';
    const opentokToken = data.opentokToken || data.token || data?.activeSession?.opentokToken || '';
    const moderatorToken = data.moderatorToken || data?.activeSession?.moderatorToken || '';

    return {
        ...data,
        apikey,
        opentokSession,
        opentokToken,
        moderatorToken,
        activeSession: {
            ...(data.activeSession || {}),
            apikey,
            opentokSession,
            opentokToken,
            moderatorToken,
        },
        // ✅ Priority 2: Add socket credentials in the expected structure
        vonage_session_details: {
            apiKey: apikey,
            sessionId: opentokSession,
            token: opentokToken,
            moderatorToken: moderatorToken,
        },
    };
};

// Read URL params once, but keep socketAuthentication available even after refreshes
const urlParams = new URLSearchParams(window.location.search);
const getValidSocketValue = (value) => {
    if (value === null || value === undefined) {
        return '';
    }

    const normalizedValue = String(value).trim();
    return normalizedValue && normalizedValue !== 'null' && normalizedValue !== 'undefined'
        ? normalizedValue
        : '';
};

const getValidSocketAuthentication = getValidSocketValue;

let socketAuthenticationParams = getValidSocketAuthentication(urlParams.get('socketAuthentication'));

// Persist socketAuthentication so anonymous/video-consultation users
// still follow the same flow after a hard refresh
if (socketAuthenticationParams) {
    window.sessionStorage.setItem('socketAuthenticationParams', socketAuthenticationParams);
} else {
    socketAuthenticationParams = getValidSocketAuthentication(
        window.sessionStorage.getItem('socketAuthenticationParams')
    );
}

const getCurrentSocketAuthenticationParams = () => {
    const resolvedSocketAuthentication =
        getValidSocketAuthentication(socketAuthenticationParams) ||
        getValidSocketAuthentication(window.sessionStorage.getItem('socketAuthenticationParams')) ||
        getValidSocketAuthentication(store.get('socketAuthentication'));

    socketAuthenticationParams = resolvedSocketAuthentication;

    if (resolvedSocketAuthentication) {
        window.sessionStorage.setItem('socketAuthenticationParams', resolvedSocketAuthentication);
    }

    return resolvedSocketAuthentication;
};

const getResolvedSocketUserId = (userId) =>
    getValidSocketValue(userId) ||
    getValidSocketValue(window.sessionStorage.getItem('userId')) ||
    getValidSocketValue(store.get('userId')) ||
    getValidSocketValue(store.get('bloomIfAI_id')) ||
    getValidSocketValue(store.get('userSession')?.id) ||
    getValidSocketValue(store.get('insAdminSession')?.id) ||
    getValidSocketValue(urlParams.get('userId'));

export const startWebSocketConnect = (userId, userType) =>
    function (dispatch) {
        if (isAppConnect) {
            return;
        }
        const socketAuthentication = store.get('userSession')
            ? store.get('userSession').socketAuthentication
            : '';
        myLog('--------------_>>>>>>  socketWeb Connect Start web', userId, userType, isAppConnect);
        const manager = Manager(URL.INS_BASE_SOCKET_URL, {
            path: URL.BASE_URL_SOCKET_IO_PATH,
            autoConnect: true,
            forceNew: true,
            verify: false,
            reconnection: true,
            reconnectionDelay: 1000,
            timeout: 5000,
            withCredentials: true, // Ensures cookies are sent with socket handshake
            query: {
                userId,
                type: userType,
                socketAuthentication,
                sessionId: window.localStorage.getItem('bypassSessionId'),
            },
        });
        socketWeb = manager.socket(NAMESPACE_WEB);
        socketCustomChat = manager.socket(NAMESPACE_CUSTOM_CHAT);
        /**
         * Connected
         */
        socketWeb.on(CONNECTE, (val) => {
            myLog('--------------_>>>>>>   Connected  web', val);
            isAppConnect = true;
        });

        socketCustomChat.on(CONNECTE, (val) => {
            myLog('--------------_>>>>>>   Connected  web', val);
            isAppConnect = true;
        });

        socketCustomChat.on(DISCONNECTED, (val) => {
            myLog('--------------_>>>>>>   DisConnected  web', val);
            isAppConnect = false;
        });
        /**
         * _onDisConnect
         */
        socketWeb.on(DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   _onDisConnect  web', data);
            isAppConnect = false;
            logSessionEvent('warn', 'WEB_SOCKET_DISCONNECTED', {
                userId,
                userType,
                status: 'disconnected',
                raw: data,
            });
        });

        /**
         * socket connected
         */
        socketWeb.on(SOCKET_CONNECTED, (data) => {
            isAppConnect = true;
            myLog('--------------_>>>>>>   socket_connected web', data);
        });

        socketCustomChat.on(SOCKET_CONNECTED, (data) => {
            isAppConnect = true;
            myLog('--------------_>>>>>>   socket_connected web', data);
        });

        /**
         * Add the ON_CHAT_MESSAGE_READ listener here
         */
        socketCustomChat.on(MESSAGE_READ, (data) => {
            dispatch({
                type: ACTION_TYPES.MESSAGE_READ,
                payload: data,
            });
        });

        /**
         * `${userType}/${userId}` - Listener
         */
        socketWeb.on(`${userType}/${userId}`, (data) => {
            myLog('--------------_>>>>>>--- web ', `${userType}/${userId}`, data);
            myLog('--------------_>>>>>>--- web *********************', Date().toLocaleString());

            const meetingSummaryPayload =
                data?.type === MEETING_SUMMARY
                    ? data
                    : data?.response?.type === MEETING_SUMMARY
                      ? data.response
                      : null;

            if (meetingSummaryPayload) {
                emitMeetingSummaryEvent(meetingSummaryPayload);
            }

            if (data.type === INACTIVE_USER) {
                dispatch(customeAction(ACTION_TYPES.INACTIVE_USER, data.type));
                var obj = {
                    email: localStorage.get('rememberMe')
                        ? localStorage.get('rememberMe').email
                        : '',
                };
                store.clearAll();
                localStorage.set('rememberMe', obj);
                clearInterval(userSessionTimer);
                clearInterval(userTokenRenewalTimer);
                try {
                    stopWebSocketConnect();
                } catch (error) {
                    //
                }
                logSessionEvent('error', 'INACTIVE_USER_FORCED_LOGOUT', {
                    userId,
                    userType,
                    status: 'error',
                });
                return { type: ACTION_TYPES.LOGOUT_USER, payload: null };
            }

            const parsedData =
                typeof data === 'string'
                    ? (() => {
                          try {
                              return JSON.parse(data);
                          } catch (error) {
                              return { type: data };
                          }
                      })()
                    : data;

            if (parsedData?.type === MEETING_SUMMARY) {
                const summarySessionId =
                    parsedData?.response?.sessionId ||
                    parsedData?.response?.visitId ||
                    parsedData?.data?.sessionId ||
                    parsedData?.data?.visitId ||
                    parsedData?.sessionId ||
                    parsedData?.visitId;
                const pendingSessionId = window.sessionStorage.getItem('LAST_VISITED_SESSION_ID');
                const shouldClearPendingState =
                    !summarySessionId ||
                    !pendingSessionId ||
                    String(summarySessionId) === String(pendingSessionId);

                // Prefer exact match when backend sends an id; fall back to clear when id is absent.
                if (shouldClearPendingState) {
                    window.sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
                    window.sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
                    window.sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
                }

                window.dispatchEvent(
                    new CustomEvent('meeting-summary-received', {
                        detail: {
                            sessionId: summarySessionId,
                            payload: parsedData,
                        },
                    })
                );

                logSessionEvent('info', 'MEETING_SUMMARY_RECEIVED', {
                    userId,
                    userType,
                    summarySessionId,
                    status: 'success',
                });
            }

            if (userType === Patient || userType === 'REGISTERED') {
                if (
                    data?.response?.visitType === Scheduled ||
                    data?.response?.visitType === OnDemand
                ) {
                    sessionStorage.setItem('VISIT_TYPE', 'one_to_one');
                } else if (data?.response?.visitType === ClassroomSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'class_room');
                } else if (data?.response?.visitType === BroadCastSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'broadcast');
                }
                if (data?.response?.visitType) {
                    logSessionEvent('info', 'VISIT_TYPE_SET', {
                        userId,
                        userType,
                        visitType: data.response.visitType,
                    });
                }
                if (data.type === VIDEO_CALL_CONNECTED) {
                    if (
                        window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                        window.location.href.indexOf('/Educator/white/board') === -1 &&
                        (data.userType === Patient || data.userType === 'REGISTERED') &&
                        data?.response?.visitType !== BroadCastSession
                        // &&
                        // _.isEmpty(
                        //   stores.getState().PushNotificationReducer.pushNotification
                    ) {
                        dispatch(pushNotification(data.response));
                    }
                    dispatch(connectVideoCall(data.response));
                    logSessionEvent('info', 'VIDEO_CALL_CONNECTED_EVENT', {
                        userId,
                        userType,
                        visitType: data?.response?.visitType,
                        status: 'success',
                        source: 'WEB_PATIENT_SIDE',
                    });
                } else if (data.type === LIVE_STREAM_STARTED) {
                    sessionStorage.setItem(
                        'broadcastUrl',
                        data?.data?.activeSession?.broadcast?.hls
                    );
                    if (
                        window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                        window.location.href.indexOf('/Educator/white/board') === -1 &&
                        (data.userType === Patient || data.userType === 'REGISTERED')
                    ) {
                        dispatch(pushNotification(data.data));
                    }
                    dispatch(connectVideoCall(data.data));
                    logSessionEvent('info', 'LIVE_STREAM_STARTED_EVENT', {
                        userId,
                        userType,
                        visitType: data?.data?.visitType,
                        status: 'success',
                        source: 'WEB_PATIENT_SIDE',
                    });
                } else if (data.type === ENDED_CALL) {
                    myLog(window.location.href.indexOf(PATH.IM_PATIENT.WAITINGROOM));
                    if (window.location.href.indexOf(PATH.IM_PATIENT.WAITINGROOM) !== -1) {
                        window.location.reload();
                    }
                    logSessionEvent('info', 'VIDEO_CALL_ENDED_EVENT', {
                        userId,
                        userType,
                        status: 'ended',
                        source: 'WEB_PATIENT_SIDE',
                    });
                } else if (data.type === NOTIFICATION_COUNT) {
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                        payload: data.response,
                    });
                } else if (data.type === ON_CHAT_MESSAGE) {
                    if (userType === Patient || userType === 'REGISTERED') {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS,
                                data.response.message
                            )
                        );
                    } else {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE,
                                data.response.message
                            )
                        );
                        data?.response?.message?.messageType !== 2 &&
                            dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                    }
                } else if (data.type === ON_MESSAGE) {
                    if (data.response.role === userType) {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS,
                                data.response.message
                            )
                        );
                    } else {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE,
                                data.response.message
                            )
                        );
                    }
                    data?.response?.message?.messageType !== 2 &&
                        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                }
            } else if (userType === Doctor) {
                const visitType = data?.response?.visitType || data?.visitType || data?.sessionType;
                if (visitType === Scheduled || visitType === OnDemand) {
                    sessionStorage.setItem('VISIT_TYPE', 'one_to_one');
                } else if (visitType === ClassroomSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'class_room');
                } else if (visitType === BroadCastSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'broadcast');
                }
                if (visitType) {
                    logSessionEvent('info', 'VISIT_TYPE_SET', {
                        userId,
                        userType,
                        visitType,
                    });
                }
                // if (data.type === VIDEO_CALL_CONNECTED) {
                //   // if (
                //   //   window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                //   //   window.location.href.indexOf("/Educator/white/board") === -1 &&
                //   //   (data.userType === "PHYSICIAN" || data.userType === "DOCTOR") &&
                //   //   data?.response?.visitType !== BroadCastSession
                //     // &&
                //     // _.isEmpty(
                //     //   stores.getState().PushNotificationReducer.pushNotification
                //   // ) {
                //     // dispatch(pushNotification(data.response));
                //   // }
                //   // dispatch(connectVideoCall(data.response));
                // }
                if (data.type === VIDEO_CALL_CONNECTED) {
                    dispatch(pushNotification(data.response));
                    logSessionEvent('info', 'VIDEO_CALL_CONNECTED_EVENT', {
                        userId,
                        userType,
                        visitType,
                        status: 'success',
                        source: 'WEB_DOCTOR_SIDE',
                        eventType: data.type,
                    });
                } else if (data.type === VONAGE_SESSION_DETAILS) {
                    const sessionPayload = normalizeVonageSessionPayload(data);

                    dispatch(pushNotification(sessionPayload));
                    dispatch(connectVideoCall(sessionPayload));

                    logSessionEvent('info', 'VIDEO_CALL_CONNECTED_EVENT', {
                        userId,
                        userType,
                        visitType,
                        status: 'success',
                        source: 'WEB_DOCTOR_SIDE',
                        eventType: data.type,
                    });
                } else if (data.type === PATIENT_CALL_INITIATION) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `One more ${Collaborator} has arrived in ${waitingRooms}`,
                            type: 'success',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                    logSessionEvent('info', 'PATIENT_JOINED_WAITING_ROOM', {
                        userId,
                        userType,
                        visitType: data?.response?.visitType,
                        status: 'success',
                        room: waitingRooms,
                    });
                } else if (data.type === VIDEO_CONSULTATION_REJOIN) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `${Collaborator} joined ${waitingRooms}`,
                            type: 'success',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                    logSessionEvent('info', 'PATIENT_REJOINED_WAITING_ROOM', {
                        userId,
                        userType,
                        visitType: data?.response?.visitType,
                        status: 'success',
                        room: waitingRooms,
                    });
                } else if (data.type === VIDEO_CONSULTATION_LEFT) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `${Collaborator} has left from ${waitingRooms}`,
                            type: 'warning',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                    logSessionEvent('info', 'PATIENT_LEFT_WAITING_ROOM', {
                        userId,
                        userType,
                        visitType: data?.response?.visitType,
                        status: 'success',
                        room: waitingRooms,
                    });
                } else if (data.type === NEW_ONDEMAND_BOOKED) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.ONDEMAND_BOOKING_CONFIRMATION,
                        payload: data.response,
                    });
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `A ${Collaborator} has just checked in!!!`,
                            type: 'success',
                            status: true,
                        })
                    );
                } else if (data.type === NEW_APPOINTMENT_BOOKED) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.APPOINTMENT_BOOKING_CONFIRMATION,
                        payload: data.response,
                    });
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: 'You have a new appointment!!!',
                            type: 'success',
                            status: true,
                        })
                    );
                } else if (data.type === NOTIFICATION_COUNT) {
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                        payload: data.response,
                    });
                } else if (data.type === ON_MESSAGE) {
                    if (data.response.role === userType) {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS,
                                data.response.message
                            )
                        );
                    } else {
                        dispatch(
                            customeAction(
                                ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE,
                                data.response.message
                            )
                        );
                    }
                    data?.response?.message?.messageType !== 2 &&
                        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                }
            }
        });

        socketCustomChat.on(`${userType}/${userId}`, (data) => {
            myLog('--------------_>>>>>>--- web ', `${userType}/${userId}`, data);
            myLog('--------------_>>>>>>--- web *********************', Date().toLocaleString());
            if (data.type === 'on_typing') {
                dispatch({
                    type: ACTION_TYPES.TYPING_INDICATOR,
                    payload: {
                        senderId: data.senderUserId,
                        receiverId: data.receiverUserId,
                        typing: data.typing,
                    },
                });
            }
            if (data.type === INACTIVE_USER) {
                dispatch(customeAction(ACTION_TYPES.INACTIVE_USER, data.type));
                var obj = {
                    email: localStorage.get('rememberMe')
                        ? localStorage.get('rememberMe').email
                        : '',
                };
                store.clearAll();
                localStorage.set('rememberMe', obj);
                clearInterval(userSessionTimer);
                clearInterval(userTokenRenewalTimer);
                try {
                    stopWebSocketConnect();
                } catch (error) {
                    //
                }
                logSessionEvent('error', 'INACTIVE_USER_FORCED_LOGOUT_CUSTOM_CHAT', {
                    userId,
                    userType,
                    status: 'error',
                });
                return { type: ACTION_TYPES.LOGOUT_USER, payload: null };
            }
            if (userType === Patient || userType === 'REGISTERED') {
                if (
                    data?.response?.visitType === Scheduled ||
                    data?.response?.visitType === OnDemand
                ) {
                    sessionStorage.setItem('VISIT_TYPE', 'one_to_one');
                } else if (data?.response?.visitType === ClassroomSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'class_room');
                } else if (data?.response?.visitType === BroadCastSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'broadcast');
                }
                if (data.type === VIDEO_CALL_CONNECTED) {
                    if (
                        window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                        window.location.href.indexOf('/Educator/white/board') === -1 &&
                        (data.userType === Patient || data.userType === 'REGISTERED') &&
                        data?.response?.visitType !== BroadCastSession
                        // &&
                        // _.isEmpty(
                        //   stores.getState().PushNotificationReducer.pushNotification
                    ) {
                        dispatch(pushNotification(data.response));
                    }
                    dispatch(connectVideoCall(data.response));
                } else if (data.type === LIVE_STREAM_STARTED) {
                    sessionStorage.setItem(
                        'broadcastUrl',
                        data?.data?.activeSession?.broadcast?.hls
                    );
                    if (
                        window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                        window.location.href.indexOf('/Educator/white/board') === -1 &&
                        (data.userType === Patient || data.userType === 'REGISTERED')
                    ) {
                        dispatch(pushNotification(data.data));
                    }
                    dispatch(connectVideoCall(data.data));
                } else if (data.type === ENDED_CALL) {
                    myLog(window.location.href.indexOf(PATH.IM_PATIENT.WAITINGROOM));
                    if (window.location.href.indexOf(PATH.IM_PATIENT.WAITINGROOM) !== -1) {
                        window.location.reload();
                    }
                } else if (data.type === NOTIFICATION_COUNT) {
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                        payload: data.response,
                    });
                } else if (data.type === UN_UNREAD_COUNT) {
                    if (userType === Patient || userType === 'REGISTERED') {
                        dispatch({
                            type: ACTION_TYPES.UPDATE_UNREAD_MESSAGE_COUNT,
                            payload: {
                                unReadMessageCount: data.unReadMessageCount,
                                receiverUserId: data.receiverUserId,
                                senderUserId: data.senderUserId,
                                unReadCountDetails: data.unReadCountDetails,
                            },
                        });
                    }
                } else if (data.type === ON_CHAT_MESSAGE) {
                    if (userType === Patient || userType === 'REGISTERED') {
                        dispatch({
                            type: ACTION_TYPES.STUDENT.CHAT_MESSAGES_LIST,
                            payload: data.response,
                        });
                    }
                } else if (data.type === ON_TYPING) {
                    dispatch({
                        type: ACTION_TYPES.TYPING_INDICATOR,
                        payload: {
                            senderUserId: data.senderUserId,
                            receiverUserId: data.receiverUserId,
                            typing: data.typing,
                        },
                    });
                } else if (data.type === 'on_read') {
                    dispatch({
                        type: ACTION_TYPES.MESSAGE_READ,
                        payload: {
                            receiverUserId: data.receiverUserId,
                            message_read: data.message_read,
                        },
                    });
                }
            } else if (userType === Doctor) {
                const visitType = data?.response?.visitType || data?.visitType || data?.sessionType;

                if (visitType === Scheduled || visitType === OnDemand) {
                    sessionStorage.setItem('VISIT_TYPE', 'one_to_one');
                } else if (visitType === ClassroomSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'class_room');
                } else if (visitType === BroadCastSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'broadcast');
                }
                if (data.type === VIDEO_CALL_CONNECTED || data.type === VONAGE_SESSION_DETAILS) {
                    const sessionPayload =
                        data.type === VONAGE_SESSION_DETAILS
                            ? normalizeVonageSessionPayload(data)
                            : data.response;

                    if (
                        window.location.href.indexOf(PATH.IM_PATIENT.VIDEO_CALL) === -1 &&
                        window.location.href.indexOf('/Educator/white/board') === -1 &&
                        (data.userType === 'PHYSICIAN' || data.userType === 'DOCTOR') &&
                        visitType !== BroadCastSession
                        // &&
                        // _.isEmpty(
                        //   stores.getState().PushNotificationReducer.pushNotification
                    ) {
                        dispatch(pushNotification(sessionPayload));
                    }
                    if (sessionPayload) {
                        dispatch(connectVideoCall(sessionPayload));
                    }
                } else if (data.type === PATIENT_CALL_INITIATION) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `One more ${Collaborator} has arrived in ${waitingRooms}`,
                            type: 'success',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                } else if (data.type === VIDEO_CONSULTATION_REJOIN) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `${Collaborator} joined ${waitingRooms}`,
                            type: 'success',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                } else if (data.type === VIDEO_CONSULTATION_LEFT) {
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `${Collaborator} has left from ${waitingRooms}`,
                            type: 'warning',
                            status: true,
                        })
                    );
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.UPDATE_WATING_ROOM_SOCKET_SUCESS,
                        payload: data.response,
                    });
                } else if (data.type === NEW_ONDEMAND_BOOKED) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.ONDEMAND_BOOKING_CONFIRMATION,
                        payload: data.response,
                    });
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: `A ${Collaborator} has just checked in!!!`,
                            type: 'success',
                            status: true,
                        })
                    );
                } else if (data.type === NEW_APPOINTMENT_BOOKED) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.APPOINTMENT_BOOKING_CONFIRMATION,
                        payload: data.response,
                    });
                    dispatch(
                        customeAction(ACTION_TYPES.SHOW_NOTIFICATION, {
                            message: 'You have a new appointment!!!',
                            type: 'success',
                            status: true,
                        })
                    );
                } else if (data.type === NOTIFICATION_COUNT) {
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                        payload: data.response,
                    });
                } else if (data.type === ON_CHAT_MESSAGE) {
                    if (userType === Doctor) {
                        dispatch({
                            type: ACTION_TYPES.STUDENT.CHAT_MESSAGES_LIST,
                            payload: data.response,
                        });
                    }
                    const msg = data.response.message;
                    const fileType = (msg.fileType || '').toLowerCase();
                    const message = msg.message;

                    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'tiff', 'svg'];
                    const videoTypes = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];
                    const audioTypes = ['mp3', 'wav', 'ogg', 'aac', 'flac', 'm4a'];
                    const pdfTypes = ['pdf'];
                    const docTypes = [
                        'doc',
                        'docx',
                        'xls',
                        'xlsx',
                        'ppt',
                        'pptx',
                        'txt',
                        'rtf',
                        'odt',
                    ];

                    let latestMessageLabel;

                    if (fileType) {
                        if (imageTypes.includes(fileType)) {
                            latestMessageLabel = 'Image';
                        } else if (videoTypes.includes(fileType)) {
                            latestMessageLabel = 'Video';
                        } else if (audioTypes.includes(fileType)) {
                            latestMessageLabel = 'Audio';
                        } else if (pdfTypes.includes(fileType)) {
                            latestMessageLabel = 'PDF';
                        } else if (docTypes.includes(fileType)) {
                            latestMessageLabel = 'Document';
                        } else {
                            latestMessageLabel = 'File';
                        }
                    } else {
                        latestMessageLabel = message || '';
                    }

                    const messageReadFlag =
                        msg.readStatus === true || msg.read === true || msg.message_read === true;

                    dispatch({
                        type: ACTION_TYPES.UPDATE_LATEST_MESSAGE,
                        payload: {
                            senderUserId: msg.senderUserId,
                            latestMessages: latestMessageLabel,
                            receiverUserId: msg.receiverUserId,
                            createdTime: msg.createdTime,
                            readStatus: messageReadFlag,
                        },
                    });
                } else if (data.type === UN_UNREAD_COUNT) {
                    if (userType === Doctor) {
                        dispatch({
                            type: ACTION_TYPES.UPDATE_UNREAD_MESSAGE_COUNT,
                            payload: {
                                unReadMessageCount: data.unReadMessageCount,
                                receiverUserId: data.receiverUserId,
                                senderUserId: data.senderUserId,
                                unReadCountDetails: data.unReadCountDetails,
                            },
                        });
                    }
                } else if (data.type === ON_TYPING) {
                    dispatch({
                        type: ACTION_TYPES.TYPING_INDICATOR,
                        payload: {
                            senderUserId: data.senderUserId,
                            receiverUserId: data.receiverUserId,
                            typing: data.typing,
                        },
                    });
                } else if (data.type === ON_CHAT_OPENED) {
                    if (userType === Doctor) {
                        dispatch({
                            type: ACTION_TYPES.UPDATE_LATEST_MESSAGE,
                            payload: {
                                senderUserId: data.senderId,
                                receiverUserId: data.receiverId,
                                messages: Array.isArray(data.messages) ? data.messages : [],
                                timestamp: data.timestamp || Date.now(),
                                readStatus: true,
                            },
                        });
                    }
                } else if (data.type === 'on_read') {
                    dispatch({
                        type: ACTION_TYPES.MESSAGE_READ,
                        payload: {
                            receiverUserId: data.receiverUserId,
                            message_read: data.message_read,
                        },
                    });
                }
            }
        });

        /**
         * socket_disconnected
         */
        socketWeb.on(SOCKET_DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   socket_disconnected web', data);
            isAppConnect = false;
            logSessionEvent('warn', 'WEB_SOCKET_DISCONNECTED_EVENT', {
                userId,
                userType,
                status: 'disconnected',
                raw: data,
            });
        });

        /**
         * socket_disconnected
         */
        socketCustomChat.on(SOCKET_DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   socket_disconnected web', data);
            isAppConnect = false;
            logSessionEvent('warn', 'CUSTOM_WEB_SOCKET_DISCONNECTED_EVENT', {
                userId,
                userType,
                status: 'disconnected',
                raw: data,
            });
        });
        /**
         * connect error
         */
        socketWeb.on(CONNECT_ERROR, (data) => {
            myLog('--------------_>>>>>>   connect_error web', data);
            logSessionEvent('error', 'WEB_SOCKET_CONNECT_ERROR', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
        /**
         * connect timeout
         */
        socketWeb.on(CONNECT_TIMEOUT, (data) => {
            myLog('--------------_>>>>>>   connect_timeout web', data);
            logSessionEvent('error', 'WEB_SOCKET_CONNECT_TIMEOUT', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
        /**
         * Wrong Information
         */
        socketWeb.on(WRONG_INFORMATION, (data) => {
            myLog('--------------_>>>>>>   Wrong Information web', data);
            logSessionEvent('error', 'WEB_SOCKET_WRONG_INFORMATION', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
    };

export const adminStartWebSocketConnect = (userId, userType) =>
    function (dispatch) {
        if (isAppConnect) {
            return;
        }
        const socketAuthentication = store.get('insAdminSession')
            ? store.get('insAdminSession').socketAuthentication
            : '';
        myLog('--------------_>>>>>>  socketWeb Connect Start web', userId, userType, isAppConnect);
        logSessionEvent('info', 'WEB_SOCKET_CONNECT_START_ADMIN', {
            userId,
            userType,
            status: 'starting',
        });
        const manager = Manager(URL.INS_BASE_SOCKET_URL, {
            path: URL.BASE_URL_SOCKET_IO_PATH,
            autoConnect: true,
            forceNew: true,
            verify: false,
            reconnection: true,
            reconnectionDelay: 1000,
            timeout: 5000,
            withCredentials: true, // Ensures cookies are sent with socket handshake
            query: {
                userId,
                type: userType,
                socketAuthentication,
                sessionId: window.localStorage.getItem('bypassSessionId'),
            },
        });
        socketWeb = manager.socket(NAMESPACE_WEB);
        /**
         * Connected
         */
        socketWeb.on(CONNECTE, (val) => {
            myLog('--------------_>>>>>>   Connected  web', val);
            isAppConnect = true;
            logSessionEvent('info', 'WEB_SOCKET_CONNECTED_ADMIN', {
                userId,
                userType,
                status: 'connected',
            });
        });

        /**
         * _onDisConnect
         */
        socketWeb.on(DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   _onDisConnect  web', data);
            isAppConnect = false;
            logSessionEvent('warn', 'WEB_SOCKET_DISCONNECTED_ADMIN', {
                userId,
                userType,
                status: 'disconnected',
                raw: data,
            });
        });

        /**
         * socket connected
         */
        socketWeb.on(SOCKET_CONNECTED, (data) => {
            // props.showNotification('socket connected', 'success');
            isAppConnect = true;
            myLog('--------------_>>>>>>   socket_connected web', data);
            logSessionEvent('info', 'WEB_SOCKET_HANDSHAKE_SUCCESS_ADMIN', {
                userId,
                userType,
                status: 'success',
            });
        });

        /**
         * `${userType}/${userId}` - Listener
         */
        socketWeb.on(`${userType}/${userId}`, (data) => {
            myLog('--------------_>>>>>>--- web ', `${userType}/${userId}`, data);
            // myLog('--------------_>>>>>>--- web *********************', Date().toLocaleString());
            if (userType === 'ADMIN') {
                if (data.type === NOTIFICATION_COUNT) {
                    const messageNotifySound = new Audio(messageSoundFile);
                    messageNotifySound.currentTime = 0;
                    messageNotifySound.play();
                    dispatch({
                        type: ACTION_TYPES.INS_SUPER_ADMIN.ADMIN_NOTIFICATION,
                        payload: data.response,
                    });
                }
            } else if (userType === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN) {
                // Level two Side
                if (data?.data?.visitType === BroadCastSession) {
                    sessionStorage.setItem('VISIT_TYPE', 'broadcast');
                }
                if (data.type === LIVE_STREAM_STARTED) {
                    sessionStorage.setItem(
                        'broadcastUrl',
                        data?.data?.activeSession?.broadcast?.hls
                    );
                    dispatch(pushNotification(data.data));
                    dispatch(connectVideoCall(data.data));
                }
            }
        });
        /**
         * socket_disconnected
         */
        socketWeb.on(SOCKET_DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   socket_disconnected web', data);
            isAppConnect = false;
            logSessionEvent('warn', 'WEB_SOCKET_DISCONNECTED_EVENT_ADMIN', {
                userId,
                userType,
                status: 'disconnected',
                raw: data,
            });
        });
        /**
         * connect error
         */
        socketWeb.on(CONNECT_ERROR, (data) => {
            myLog('--------------_>>>>>>   connect_error web', data);
            logSessionEvent('error', 'WEB_SOCKET_CONNECT_ERROR_ADMIN', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
        /**
         * connect timeout
         */
        socketWeb.on(CONNECT_TIMEOUT, (data) => {
            myLog('--------------_>>>>>>   connect_timeout web', data);
            logSessionEvent('error', 'WEB_SOCKET_CONNECT_TIMEOUT_ADMIN', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
        /**
         * Wrong Information
         */
        socketWeb.on(WRONG_INFORMATION, (data) => {
            myLog('--------------_>>>>>>   Wrong Information web', data);
            logSessionEvent('error', 'WEB_SOCKET_WRONG_INFORMATION_ADMIN', {
                userId,
                userType,
                status: 'error',
                raw: data,
            });
        });
    };

/**
 * Starts chat socket connection
 * @param {Number} userId
 * @param {String} userType
 * @param {Number} visitId
 * @param {Object} props
 */
export const startChatSocketConnect = (userId, userType, visitId, props) =>
    function (dispatch) {
        setActiveWhiteboardSession(visitId);
        pruneWhiteboardSessionsExcept(visitId);
        sessionStorage.setItem('userId', userId);
        sessionStorage.setItem('visitId', visitId);
        dispatch(socketServerDownProblem(false));
        myLog('--------------_>>>>>>  socketWeb Connect Start Chat', props);
        logSessionEvent('info', 'CHAT_SOCKET_CONNECT_START', {
            userId,
            userType,
            visitId,
            visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
            path: window.location.pathname,
        });
        if (isChatConnect) {
            return;
        }

        const socketAuthentication = store.get('userSession')
            ? store.get('userSession').socketAuthentication
            : store.get('insAdminSession')
              ? store.get('insAdminSession').socketAuthentication
              : store.get('socketAuthentication')
                ? store.get('socketAuthentication')
                : '';
        const activeSocketAuthenticationParams = getCurrentSocketAuthenticationParams();
        const query = {
            userId,
            type: userType,
            visitId,
            sessionId: window.localStorage.getItem('bypassSessionId'),
            socketAuthentication,
        };

        if (activeSocketAuthenticationParams) {
            query.funcType = 'video_consultation';
            logSessionEvent('info', 'VIDEO_CONSULTATION_SOCKET_AUTH_USER', {
                userId,
                userType,
                visitId,
                funcType: query.funcType,
                socketAuthenticationParams: activeSocketAuthenticationParams,
            });
        }
        const manager = Manager(URL.INS_BASE_SOCKET_URL, {
            path: URL.BASE_URL_SOCKET_IO_PATH,
            autoConnect: true,
            forceNew: true,
            verify: false,
            reconnection: true,
            reconnectionDelay: 1000,
            timeout: 2000,
            withCredentials: true, // Ensures cookies are sent with socket handshake
            query,
            // query: {
            //     userId,
            //     type: userType,
            //     visitId,
            //     socketAuthentication,
            //     sessionId: window.localStorage.getItem('bypassSessionId'),
            // },
        });
        socketChat = manager.socket(NAMESPACE_CHAT);

        /**
         * NOTE: streamId and liveCaption events are received through VISIT/${visitId} channel
         * NOT as direct socket events. See VISIT listener below (line ~1520+) for handling.
         * Direct listeners on 'on_stream_id_created' would never receive anything from server.
         */

        /**
         * Connected
         */
        socketChat.on(CONNECTE, (val) => {
            myLog('--------------_>>>>>>   Connected Chat', val);
            isChatConnect = true;
            logSessionEvent('info', 'CHAT_SOCKET_CONNECTED', {
                userId,
                userType,
                visitId,
                visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                status: 'success',
            });
        });
        /**
         * _onDisConnect
         */
        socketChat.on(DISCONNECTED, (data) => {
            dispatch(socketServerDownProblem(true));
            myLog('--------------_>>>>>>   _onDisConnect Chat', data);
            isChatConnect = false;
            logSessionEvent('warn', 'CHAT_SOCKET_DISCONNECTED', {
                userId,
                userType,
                visitId,
                visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                status: 'disconnected',
                raw: data,
            });
        });
        /**
         * socket connected
         */
        socketChat.on(SOCKET_CONNECTED, (data) => {
            // console.log(data, "visitID DATA FIRST");
            dispatch(socketServerDownProblem(false));
            myLog('--------------_>>>>>>   socket_connected Chat', data);
            isChatConnect = true;
            logSessionEvent('info', 'CHAT_SOCKET_HANDSHAKE_SUCCESS', {
                userId,
                userType,
                visitId,
                visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                status: 'success',
                socketAuthenticationParams: !!activeSocketAuthenticationParams,
            });
            if (userType === Doctor) {
                const data = {
                    visitId,
                    userId,
                };
                const visitType = sessionStorage.getItem('VISIT_TYPE');

                if (
                    visitType === 'class_room' ||
                    visitType === 'broadcast' ||
                    visitType === ConferenceCall
                ) {
                    socketChat.emit(EMIT_ON_CLASSROOM_CONNECT, data);
                    logSessionEvent('info', 'DOCTOR_JOINED_SESSION', {
                        userId,
                        userType,
                        visitId,
                        sessionJoinType: visitType,
                        visitType,
                        emitEvent: 'EMIT_ON_CLASSROOM_CONNECT',
                        status: 'success',
                    });
                } else if (visitType === 'one_to_one') {
                    // console.log('Emitting EMIT_ON_DOCTOR_CONNECT for one_to_one session');
                    socketChat.emit(EMIT_ON_DOCTOR_CONNECT, data);
                    logSessionEvent('info', 'DOCTOR_JOINED_SESSION', {
                        userId,
                        userType,
                        visitId,
                        sessionJoinType: visitType,
                        visitType,
                        emitEvent: 'EMIT_ON_DOCTOR_CONNECT',
                        status: 'success',
                    });
                } else {
                    // console.log('Emitting EMIT_ON_DOCTOR_CONNECT for UNEXPECTED_VISIT_TYPE_ON_DOCTOR_CONNECT');

                    // Fallback to one_to_one connect, but log unexpected visit type
                    socketChat.emit(EMIT_ON_DOCTOR_CONNECT, data);
                    logSessionEvent('error', 'UNEXPECTED_VISIT_TYPE_ON_DOCTOR_CONNECT', {
                        userId,
                        userType,
                        visitId,
                        visitType,
                        emitEvent: 'EMIT_ON_DOCTOR_CONNECT',
                        fallbackEmit: 'EMIT_ON_DOCTOR_CONNECT',
                    });
                }
            } else if (activeSocketAuthenticationParams) {
                const userId = getResolvedSocketUserId();
                const visitId = sessionStorage.getItem('visitId') || urlParams.get('visitId');
                const sessionType = new URLSearchParams(window.location.search)
                    .get('sessionType')
                    ?.toLowerCase()
                    .trim();
                const isGroupSession = sessionType === 'group session';

                const data = {
                    visitId,
                    userId,
                };
                if (isGroupSession) {
                    // console.log('Emitting EMIT_ON_CLASSROOM_CONNECT for group session');
                    socketChat.emit(EMIT_ON_CLASSROOM_CONNECT, data);
                    logSessionEvent('info', 'ANONYMOUS_JOINED_SESSION', {
                        userId,
                        userType: 'ANONYMOUS',
                        visitId,
                        sessionType,
                        sessionJoinType: 'group',
                        emitEvent: 'EMIT_ON_CLASSROOM_CONNECT',
                        status: 'success',
                    });
                } else {
                    // console.log('Emitting EMIT_ON_CLASSROOM_CONNECT for group session');
                    socketChat.emit(EMIT_ON_DOCTOR_CONNECT, data);
                    logSessionEvent('info', 'ANONYMOUS_JOINED_SESSION', {
                        userId,
                        userType: 'ANONYMOUS',
                        visitId,
                        sessionType,
                        sessionJoinType: 'one_to_one',
                        emitEvent: 'EMIT_ON_DOCTOR_CONNECT',
                        status: 'success',
                    });
                }
            }
        });
        /**
         * `VISIT/${visitId}` - Listener
         * CRITICAL: This listener is set up with visitId from closure
         * If visitId changes during session, this listener will miss events!
         */
        // console.log('🎧 [LISTENER SETUP] Registering VISIT channel listener:', {
        //     channel: `VISIT/${visitId}`,
        //     visitId: visitId,
        //     closureVisitId: visitId,
        //     sessionStorageVisitId: sessionStorage.getItem('visitId'),
        //     userId: userId,
        //     userType: userType,
        //     timestamp: new Date().toISOString()
        // });

        socketChat.on(`VISIT/${visitId}`, (data) => {
            const visitEventType = data?.type || data?.data?.type || data?.response?.type;
            const visitEventPayload = data?.data?.data || data?.data || data?.response || data;
            // const currentVisitId = sessionStorage.getItem('visitId') || store.get('visitId');
            // const receivedBy =
            //     store.get('bloomIfAI_id') || store.get('userSession')?.id || store.get('userId');
            // console.log('📨 [VISIT CHANNEL] Received event:', {
            //     type: data.type,
            //     receivedBy: receivedBy,
            //     channel: `VISIT/${visitId}`,
            //     closureVisitId: visitId,
            //     currentVisitId: currentVisitId,
            //     visitIdMatch: visitId === currentVisitId,
            //     timestamp: new Date().toISOString(),
            //     eventData: data
            // });

            // console.log(data,"visitID DATA SECOND");

            if (userType === Doctor) {
                // Doctor Side
                if (data.type === DOCTOR_END_CALL) {
                    clearWhiteboardDataForSession(visitId);
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                        payload: false,
                    });
                    // props.showNotification("Your owner have ended the session", "error");
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    logSessionEvent('info', 'DOCTOR_LEFT_SESSION', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        reason: 'DOCTOR_END_CALL',
                        status: 'success',
                    });
                    setMeetingSummaryPendingForSession(visitId);
                    props.history.push(`${PATH.IM_PHYSICIAN.APPOINTMENT}/${userId}`);
                }
                if (data.type === PATIENT_CALL_END) {
                    sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                        props.showNotification(data.message, 'warning');
                    logSessionEvent('info', 'PATIENT_LEFT_SESSION', {
                        userId,
                        userType: Patient,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        reason: 'PATIENT_CALL_END',
                        status: 'success',
                    });
                } else if (data.type === VIDEO_CALL_CONNECTED) {
                    dispatch(connectVideoCall(data.response));
                    logSessionEvent('info', 'VIDEO_CALL_CONNECTED_EVENT', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        status: 'success',
                        source: 'DOCTOR_SIDE',
                    });
                } else if (data.type === PATIENT_BUSY) {
                    sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                        props.showNotification(data.message, 'warning');
                } else if (data.type === PATIENT_CONNECTED) {
                    if (
                        sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                        sessionStorage.getItem('VISIT_TYPE') === 'broadcast'
                    ) {
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    } else {
                        sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                            props.showNotification(data.message, 'success');
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    }
                } else if (data.type === ANONYMOUS_USER_CONNECTED) {
                    if (
                        sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                        sessionStorage.getItem('VISIT_TYPE') === 'one_to_one'
                    ) {
                        props.showNotification(data.message, 'success');
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    } else {
                        sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                            props.showNotification(data.message, 'success');
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    }
                } else if (data.type === ANONYMOUS_USER_DISCONNECTION) {
                    if (
                        sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                        sessionStorage.getItem('VISIT_TYPE') === 'one_to_one'
                    ) {
                        props.showNotification(data.message, 'error');
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    } else {
                        sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                            props.showNotification(data.message, 'success');
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    }
                } else if (data.type === PATIENT_DISCONNECTION) {
                    if (
                        sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                        sessionStorage.getItem('VISIT_TYPE') === 'broadcast'
                    ) {
                        return null;
                    } else {
                        props.showNotification(data.message, 'error');
                        logSessionEvent('warn', 'PATIENT_DISCONNECTED', {
                            userId,
                            userType: Patient,
                            visitId,
                            visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                            status: 'error',
                            raw: data,
                        });
                    }
                } else if (data.type === DOCTOR_END_CALL) {
                    clearWhiteboardDataForSession(visitId);
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                        payload: false,
                    });
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    logSessionEvent('info', 'DOCTOR_LEFT_SESSION', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        reason: 'DOCTOR_END_CALL',
                        status: 'success',
                    });
                } else if (data.type === STUDENT_PARTICIPATION_LIST) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.LIVE_STREAM_PARTICIPANTS,
                        payload: data,
                    });
                }
                if (data.type === ON_WHITEBOARD_MESSAGE) {
                    const whiteboardMessage = data?.response?.message?.message;
                    if (whiteboardMessage) {
                        saveWhiteboardDataForSession(visitId, whiteboardMessage);
                    }
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_DRAW,
                        payload: {
                            visitId: visitId,
                            senderUserId: data.response.message.senderUserId,
                            whiteBoardDrawList: data.response.message.message,
                        },
                    });
                }
                if (data.type === WHITEBOARD_OPEN_MESSAGE) {
                    const whiteboardVisitId = data?.data?.visitId || visitId;
                    if (whiteboardVisitId && String(whiteboardVisitId) !== String(visitId)) {
                        return;
                    }
                    if (whiteboardVisitId) {
                        setActiveWhiteboardSession(whiteboardVisitId);
                    }
                    if (data?.data?.shouldClearWhiteboard && whiteboardVisitId) {
                        clearWhiteboardDataForSession(whiteboardVisitId);
                    }
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_OPEN,
                        payload: {
                            isWhiteboardOpen: data.data.isWhiteboardOpen,
                            sessionType: data.data.sessionType,
                        },
                    });
                }
            } else if (userType === Patient || userType === 'REGISTERED') {
                if (data.type === VIDEO_CALL_CONNECTED) {
                    dispatch(connectVideoCall(data.response));
                    logSessionEvent('info', 'VIDEO_CALL_CONNECTED_EVENT', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        status: 'success',
                        source: 'PATIENT_SIDE',
                    });
                } else if (data.type === PATIENT_CONNECTED) {
                    dispatch({
                        type: ACTION_TYPES.PATIENT.SHOWTIMER,
                        payload: true,
                    });
                } else if (data.type === EDUCATOR_MUTE_MESSAGE) {
                    sessionStorage.setItem('isEducatorMuted', data.data.isMute);
                } else if (data.type === DOCTOR_BUSY) {
                    sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                        props.showNotification(data.message, 'warning');
                } else if (data.type === DOCTOR_CONNECTED) {
                    sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                        props.showNotification(data.message, 'success');
                } else if (data.type === DOCTOR_DISCONNECTION) {
                    sessionStorage.getItem('VISIT_TYPE') === 'one_to_one' &&
                        props.showNotification(data.message, 'error');
                } else if (
                    data.type === DOCTOR_END_CALL &&
                    sessionStorage.getItem('VISIT_TYPE') !== 'broadcast'
                ) {
                    clearWhiteboardDataForSession(visitId);
                    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                        payload: false,
                    });
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    props.showNotification('Your Owner has ended the session', 'error');
                    logSessionEvent('info', 'PATIENT_LEFT_SESSION', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        reason: 'DOCTOR_END_CALL',
                        status: 'success',
                    });
                    const userTypeBySession = store.get('userSession').userType;
                    if (userTypeBySession === 'GUEST') {
                        props.history.push(`${PATH.GUEST.GUEST_WAITINGROOM}/${userId}/${visitId}`);
                    } else {
                        setMeetingSummaryPendingForSession(visitId);
                        props.history.push(`${PATH.IM_PATIENT.APPOINTMENT}/${userId}`);
                    }
                } else if (
                    data.type === DOCTOR_END_CALL &&
                    sessionStorage.getItem('VISIT_TYPE') === RESPONSE_CONSTANT.BROADCAST
                ) {
                    clearWhiteboardDataForSession(visitId);
                    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                        payload: false,
                    });
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    setTimeout(() => {
                        props.showNotification('Your Owner has ended the session', 'error');
                    }, 5000);
                    logSessionEvent('info', 'PATIENT_LEFT_SESSION', {
                        userId,
                        userType,
                        visitId,
                        visitType: sessionStorage.getItem('VISIT_TYPE') || undefined,
                        reason: 'DOCTOR_END_CALL_BROADCAST',
                        status: 'success',
                    });
                    setTimeout(() => {
                        const userTypeBySession = store.get('userSession').userType;
                        if (userTypeBySession === RESPONSE_CONSTANT.REGISTERED) {
                            setMeetingSummaryPendingForSession(visitId);
                            props.history.push(`${PATH.IM_PATIENT.APPOINTMENT}/${userId}`);
                        }
                    }, 5000);
                } else if (data.type === PHYSICIAN_CAMERA_ON) {
                    // props.showNotification(data.message, "success");
                    dispatch({
                        type: ACTION_TYPES.PATIENT.PHYSICIAN_CAMERA_ON,
                        payload: data.type,
                    });
                } else if (data.type === PHYSICIAN_CAMERA_OFF) {
                    // props.showNotification(data.message, "success");
                    dispatch({
                        type: ACTION_TYPES.PATIENT.PHYSICIAN_CAMERA_OFF,
                        payload: data.type,
                    });
                } else if (data.type === WHITEBOARD_OPEN_MESSAGE) {
                    const whiteboardVisitId = data?.data?.visitId || visitId;
                    if (whiteboardVisitId && String(whiteboardVisitId) !== String(visitId)) {
                        return;
                    }
                    if (whiteboardVisitId) {
                        setActiveWhiteboardSession(whiteboardVisitId);
                    }
                    if (data?.data?.shouldClearWhiteboard && whiteboardVisitId) {
                        clearWhiteboardDataForSession(whiteboardVisitId);
                    }
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_OPEN,
                        payload: {
                            isWhiteboardOpen: data.data.isWhiteboardOpen,
                            sessionType: data.data.sessionType,
                        },
                    });
                }
            } else if (userType === RESPONSE_CONSTANT.LEVEL_TWO_ADMIN) {
                // Level two Side
                if (data.type === VIDEO_CALL_CONNECTED) {
                    dispatch(connectVideoCall(data.response));
                } else if (data.type === PATIENT_CONNECTED) {
                    if (
                        sessionStorage.getItem('VISIT_TYPE') === 'class_room' ||
                        sessionStorage.getItem('VISIT_TYPE') === 'broadcast'
                    ) {
                        dispatch({
                            type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                            payload: true,
                        });
                    }
                } else if (data.type === DOCTOR_END_CALL) {
                    clearWhiteboardDataForSession(visitId);
                    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.SHOWTIMER,
                        payload: false,
                    });
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    props.history.push(`/level-two/${userId}/sessions/summary/${visitId}`);
                    props.showNotification('Educator has ended the session', 'error');
                } else if (data.type === STUDENT_PARTICIPATION_LIST) {
                    dispatch({
                        type: ACTION_TYPES.PHYSICIAN.LIVE_STREAM_PARTICIPANTS,
                        payload: data,
                    });
                } else if (data.type === WHITEBOARD_OPEN_MESSAGE) {
                    const whiteboardVisitId = data?.data?.visitId || visitId;
                    if (whiteboardVisitId && String(whiteboardVisitId) !== String(visitId)) {
                        return;
                    }
                    if (whiteboardVisitId) {
                        setActiveWhiteboardSession(whiteboardVisitId);
                    }
                    if (data?.data?.shouldClearWhiteboard && whiteboardVisitId) {
                        clearWhiteboardDataForSession(whiteboardVisitId);
                    }
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_OPEN,
                        payload: {
                            isWhiteboardOpen: data.data.isWhiteboardOpen,
                            sessionType: data.data.sessionType,
                        },
                    });
                }
            } else if (activeSocketAuthenticationParams) {
                if (data.type === DOCTOR_CONNECTED) {
                    props.showNotification(data.message, 'success');
                }
                if (data.type === DOCTOR_DISCONNECTION) {
                    props.showNotification(data.message, 'error');
                }
                if (data.type === VIDEO_CALL_CONNECTED) {
                    dispatch(connectVideoCall(data.response));
                }
                if (data.type === NEW_SESSION_DETAILS) {
                    // Handle new_session_details for anonymous users
                    // This provides sessionUsers, externalUsersDetails, and all session metadata
                    const sessionData = data.data;

                    // CRITICAL: Check if visitId changes
                    // const currentVisitId =
                    //     sessionStorage.getItem('visitId') || store.get('visitId');
                    // const newVisitId = sessionData?.visitId || sessionData?.id || currentVisitId;
                    // const visitIdChanged = String(newVisitId) !== String(currentVisitId);

                    // PRODUCTION FIX: Get existing session data from multiple sources
                    // Try sessionStorage first (most reliable), then Redux store
                    let existingSessionData = null;

                    // console.log('🔍 [Session Data] Attempting to retrieve existing session data...');

                    // Try getting from Redux store
                    const reduxData = store.get('studentDetails') || store.get('visitInformation');
                    // console.log('🔍 [Session Data] Redux store check:', {
                    //     hasStudentDetails: !!store.get('studentDetails'),
                    //     hasVisitInformation: !!store.get('visitInformation'),
                    //     reduxData: reduxData ? {
                    //         hasSessionUsers: !!reduxData.sessionUsers,
                    //         sessionUsersCount: reduxData.sessionUsers?.length,
                    //         hasExternalUsers: !!reduxData.externalUsersDetails,
                    //         externalUsersCount: reduxData.externalUsersDetails?.length
                    //     } : null
                    // });

                    // Try getting from sessionStorage cache (saved on previous update)
                    try {
                        const cachedData = sessionStorage.getItem('currentSessionData');
                        if (cachedData) {
                            const parsed = JSON.parse(cachedData);
                            // console.log('🔍 [Session Data] SessionStorage cache found:', {
                            //     hasSessionUsers: !!parsed.sessionUsers,
                            //     sessionUsersCount: parsed.sessionUsers?.length,
                            //     hasExternalUsers: !!parsed.externalUsersDetails,
                            //     externalUsersCount: parsed.externalUsersDetails?.length
                            // });
                            existingSessionData = parsed;
                        }
                    } catch (e) {
                        console.warn('⚠️ [Session Data] Failed to read cache:', e);
                    }

                    // Fallback to Redux if cache not available
                    if (!existingSessionData && reduxData) {
                        existingSessionData = reduxData;
                        // console.log('🔍 [Session Data] Using Redux data as fallback');
                    }

                    // Save current state BEFORE updating (for next time)
                    if (
                        existingSessionData?.sessionUsers ||
                        existingSessionData?.externalUsersDetails
                    ) {
                        try {
                            const dataToCache = {
                                sessionUsers: existingSessionData.sessionUsers || [],
                                externalUsersDetails:
                                    existingSessionData.externalUsersDetails || [],
                                timestamp: Date.now(),
                            };
                            sessionStorage.setItem(
                                'previousSessionData',
                                JSON.stringify(dataToCache)
                            );
                            sessionStorage.setItem(
                                'currentSessionData',
                                JSON.stringify(dataToCache)
                            );

                            // console.log('💾 [Session Data] Saved session data:', {
                            //     sessionUsersCount: dataToCache.sessionUsers.length,
                            //     sessionUserIds: dataToCache.sessionUsers.map(u => ({ userId: u.userId, name: u.name })),
                            //     externalUsersCount: dataToCache.externalUsersDetails.length,
                            //     externalUserIds: dataToCache.externalUsersDetails.map(u => ({ userId: u.userId, name: u.name }))
                            // });
                        } catch (e) {
                            console.error('❌ [Session Data] Failed to save session data:', e);
                        }
                    } else {
                        console.warn('⚠️ [Session Data] No existing session data found to save');
                    }

                    // PRODUCTION FIX: Preserve existing user data by merging with new session details
                    // This prevents losing user information when server sends incomplete data
                    const existingSessionUsers = existingSessionData?.sessionUsers || [];
                    const existingExternalUsers = existingSessionData?.externalUsersDetails || [];

                    // console.log('🔄 [Session Merge] Starting merge:', {
                    //     existingSessionUsersCount: existingSessionUsers.length,
                    //     newSessionUsersCount: sessionData?.sessionUsers?.length || 0,
                    //     existingExternalUsersCount: existingExternalUsers.length,
                    //     newExternalUsersCount: sessionData?.externalUsersDetails?.length || 0
                    // });

                    // Merge sessionUsers: Keep existing users not in new data
                    const newSessionUsers = sessionData?.sessionUsers || [];
                    const mergedSessionUsers = [...newSessionUsers];

                    // Add existing users that are missing from new data (preserves rejoining users)
                    existingSessionUsers.forEach((existingUser) => {
                        const existsInNew = newSessionUsers.some(
                            (u) => u.userId === existingUser.userId
                        );
                        if (!existsInNew && existingUser.userId) {
                            mergedSessionUsers.push(existingUser);
                            // console.log('🔄 [Session Merge] Preserved existing user:', {
                            //     userId: existingUser.userId,
                            //     name: existingUser.name,
                            //     reason: 'missing_from_new_session_details'
                            // });
                        }
                    });

                    // Merge externalUsersDetails: Fix undefined userId by preserving from existing data
                    const newExternalUsers = sessionData?.externalUsersDetails || [];
                    const mergedExternalUsers = newExternalUsers.map((newUser) => {
                        // If userId is undefined/null, try to find it in existing data by name
                        if (!newUser.userId || newUser.userId === 'undefined') {
                            const existingMatch = existingExternalUsers.find(
                                (u) => u.name === newUser.name
                            );
                            if (existingMatch?.userId) {
                                // console.log('🔄 [Session Merge] Restored userId for external user:', {
                                //     name: newUser.name,
                                //     restoredUserId: existingMatch.userId,
                                //     reason: 'undefined_in_new_data'
                                // });
                                return { ...newUser, userId: existingMatch.userId };
                            }
                        }
                        return newUser;
                    });

                    // Add existing external users not in new data
                    existingExternalUsers.forEach((existingUser) => {
                        const existsInNew = mergedExternalUsers.some(
                            (u) =>
                                (u.userId && u.userId === existingUser.userId) ||
                                u.name === existingUser.name
                        );
                        if (!existsInNew && existingUser.userId) {
                            mergedExternalUsers.push(existingUser);
                            // console.log('🔄 [Session Merge] Preserved existing external user:', {
                            //     userId: existingUser.userId,
                            //     name: existingUser.name,
                            //     reason: 'missing_from_new_session_details'
                            // });
                        }
                    });

                    // Create merged session data
                    const mergedSessionData = {
                        ...sessionData,
                        sessionUsers: mergedSessionUsers,
                        externalUsersDetails: mergedExternalUsers,
                    };

                    // BUILD PERSISTENT IDENTITY MAP: Track all userId/name combinations
                    // This enables matching across multiple identity changes (when server sends different userIds for same person)
                    try {
                        // Load existing identity map from sessionStorage
                        let identityMap = {};
                        const cachedIdentityMap = sessionStorage.getItem('userIdentityMap');
                        if (cachedIdentityMap) {
                            identityMap = JSON.parse(cachedIdentityMap);
                            // Convert arrays back to Sets for easier manipulation
                            Object.keys(identityMap).forEach((key) => {
                                if (
                                    identityMap[key]?.names &&
                                    Array.isArray(identityMap[key].names)
                                ) {
                                    identityMap[key].names = new Set(identityMap[key].names);
                                }
                            });
                        }

                        // Add ALL users (merged data includes existing + new users) to identity map
                        const allUsers = [...mergedSessionUsers, ...mergedExternalUsers];

                        allUsers.forEach((user) => {
                            if (user.userId && user.name && user.userId !== 'undefined') {
                                // Initialize entry if first time seeing this userId
                                if (!identityMap[user.userId]) {
                                    identityMap[user.userId] = {
                                        names: new Set(),
                                        userId: user.userId,
                                    };
                                }

                                // Add this name to the set (handles Set or creating new Set)
                                if (identityMap[user.userId].names instanceof Set) {
                                    identityMap[user.userId].names.add(user.name);
                                } else {
                                    identityMap[user.userId].names = new Set([user.name]);
                                }

                                // Reverse lookup: name → userId (points to this userId)
                                identityMap[`name:${user.name}`] = user.userId;
                            }
                        });

                        // Convert Sets to Arrays for sessionStorage (doesn't support Sets)
                        const serializableMap = {};
                        Object.keys(identityMap).forEach((key) => {
                            if (identityMap[key]?.names instanceof Set) {
                                serializableMap[key] = {
                                    ...identityMap[key],
                                    names: Array.from(identityMap[key].names),
                                };
                            } else {
                                serializableMap[key] = identityMap[key];
                            }
                        });

                        // Save to sessionStorage
                        sessionStorage.setItem('userIdentityMap', JSON.stringify(serializableMap));

                        // console.log('🗺️ [Identity Map] Updated after new_session_details:', {
                        //     totalUsers: allUsers.length,
                        //     totalEntries: Object.keys(identityMap).filter(k => !k.startsWith('name:')).length,
                        //     mappings: Object.keys(identityMap)
                        //         .filter(k => !k.startsWith('name:'))
                        //         .map(userId => ({
                        //             userId,
                        //             names: identityMap[userId].names instanceof Set
                        //                 ? Array.from(identityMap[userId].names)
                        //                 : identityMap[userId].names
                        //         }))
                        // });
                    } catch (e) {
                        console.error('❌ [Identity Map] Failed to build identity map:', e);
                    }

                    // DETAILED LOGGING: Show exactly what data we received and merged
                    // console.log('🔄 [Socket] Received new_session_details - FULL DATA:', {
                    //     hasSessionData: !!sessionData,
                    //     hasSessionUsers: Array.isArray(sessionData?.sessionUsers),
                    //     sessionUsersCount: sessionData?.sessionUsers?.length || 0,
                    //     sessionUsersDetails: sessionData?.sessionUsers?.map(u => ({
                    //         userId: u.userId,
                    //         name: u.name,
                    //         hasUserId: !!u.userId
                    //     })),
                    //     hasExternalUsers: Array.isArray(sessionData?.externalUsersDetails),
                    //     externalUsersCount: sessionData?.externalUsersDetails?.length || 0,
                    //     externalUsersDetails: sessionData?.externalUsersDetails?.map(u => ({
                    //         userId: u.userId,
                    //         name: u.name,
                    //         hasUserId: !!u.userId,
                    //         allFields: Object.keys(u)
                    //     })),
                    //     MERGED_DATA: {
                    //         sessionUsersCount: mergedSessionUsers.length,
                    //         externalUsersCount: mergedExternalUsers.length,
                    //         preservedSessionUsers: mergedSessionUsers.length - (sessionData?.sessionUsers?.length || 0),
                    //         preservedExternalUsers: mergedExternalUsers.length - (sessionData?.externalUsersDetails?.length || 0),
                    //         restoredUserIds: mergedExternalUsers.filter(u => u.userId && u.userId !== 'undefined').length
                    //     },
                    //     otherFields: Object.keys(sessionData || {}),
                    //     timestamp: new Date().toISOString(),
                    //     // CRITICAL: visitId change detection
                    //     VISIT_ID_CHECK: {
                    //         closureVisitId: visitId,
                    //         currentVisitId: currentVisitId,
                    //         newVisitId: newVisitId,
                    //         visitIdChanged: visitIdChanged,
                    //         WARNING: visitIdChanged ? '⚠️ VISIT ID CHANGED - Socket listener channel mismatch!' : 'visitId unchanged'
                    //     }
                    // });

                    // Dispatch MERGED session details (preserves existing users)
                    dispatch({
                        type: ACTION_TYPES.IM_PHYSICIAN.GET_VISIT_INFORMATION,
                        payload: mergedSessionData,
                    });

                    // console.log('✅ [Socket] Dispatched new_session_details to Redux - will update props.studentDetails');

                    // Set flag to trigger stream re-emission ONLY if there might be unmatched streams
                    // Check if this new_session_details contains NEW users that weren't in our identity map
                    const shouldTriggerReEmission = (() => {
                        try {
                            const identityMapRaw = sessionStorage.getItem('userIdentityMap');
                            if (!identityMapRaw) {
                                // No identity map yet, definitely need to match streams
                                return true;
                            }

                            const identityMap = JSON.parse(identityMapRaw);
                            const allNewUsers = [...mergedSessionUsers, ...mergedExternalUsers];

                            // Check 1: New userId not in identity map
                            const hasNewUsers = allNewUsers.some((user) => {
                                if (!user.userId || user.userId === 'undefined') return false;
                                return !identityMap[user.userId];
                            });

                            // Check 2: Same name but different userId (rejoin with new identity)
                            const hasUserIdChange = allNewUsers.some((user) => {
                                if (!user.userId || !user.name || user.userId === 'undefined')
                                    return false;
                                const mappedUserId = identityMap[`name:${user.name}`];
                                // If name exists in map but points to different userId, this is a rejoin
                                return mappedUserId && mappedUserId !== user.userId;
                            });

                            // Check 3: Unmatched streams from previous attempts
                            const hasUnmatchedStreams =
                                sessionStorage.getItem('hasUnmatchedStreams') === 'true';

                            // if (hasNewUsers) {
                            //     console.log('🔍 [Re-Emission Check] New users detected');
                            // }
                            // if (hasUserIdChange) {
                            //     console.log('🔍 [Re-Emission Check] User identity change detected (rejoin with new userId)');
                            // }
                            // if (hasUnmatchedStreams) {
                            //     console.log('🔍 [Re-Emission Check] Unmatched streams exist');
                            // }

                            return hasNewUsers || hasUserIdChange || hasUnmatchedStreams;
                        } catch (e) {
                            console.error('❌ [Re-Emission Check] Error:', e);
                            return false; // Don't trigger on error
                        }
                    })();

                    if (shouldTriggerReEmission) {
                        sessionStorage.setItem('pendingStreamReEmission', 'true');
                        // console.log('🔄 [Socket] Set pendingStreamReEmission flag - new users/identity changes detected or unmatched streams exist');
                    } else {
                        // console.log('ℹ️ [Socket] Skipping pendingStreamReEmission - all users already in identity map with unchanged identities');
                    }

                    logSessionEvent('info', 'ANONYMOUS_SESSION_DETAILS_RECEIVED', {
                        userId,
                        userType: Anonymous,
                        visitId,
                        visitType: sessionData?.visitType || sessionData?.sessionType,
                        status: 'success',
                        hasSessionUsers: Array.isArray(sessionData?.sessionUsers),
                        sessionUsersCount: sessionData?.sessionUsers?.length || 0,
                        hasExternalUsers: Array.isArray(sessionData?.externalUsersDetails),
                        externalUsersCount: sessionData?.externalUsersDetails?.length || 0,
                    });
                }
                if (data.type === DOCTOR_END_CALL) {
                    clearWhiteboardDataForSession(visitId);
                    setTimeout(() => {
                        const ownerOrDoctorLabel = getTranslation(
                            AppConfig.isHealthCare ? 'doctor' : 'owner'
                        );
                        props.showNotification(
                            `${getTranslation('your')} ${ownerOrDoctorLabel} ${getTranslation('hasEndedTheSession')}`,
                            'error'
                        );
                    }, 5000);
                    dispatch({
                        type: ACTION_TYPES.ANONYMOUS_SIDE_DOCTOR_END_CALL,
                        payload: data,
                    });
                }
                if (data.type === WHITEBOARD_OPEN_MESSAGE) {
                    const whiteboardVisitId = data?.data?.visitId || visitId;
                    if (whiteboardVisitId && String(whiteboardVisitId) !== String(visitId)) {
                        return;
                    }
                    if (whiteboardVisitId) {
                        setActiveWhiteboardSession(whiteboardVisitId);
                    }
                    if (data?.data?.shouldClearWhiteboard && whiteboardVisitId) {
                        clearWhiteboardDataForSession(whiteboardVisitId);
                    }
                    dispatch({
                        type: ACTION_TYPES.WHITE_BOARD_OPEN,
                        payload: {
                            isWhiteboardOpen: data.data.isWhiteboardOpen,
                            sessionType: data.data.sessionType,
                        },
                    });
                }
            }
            // Handle streamId mappings received from other participants
            // CRITICAL: Uses dynamic visitId to handle session context changes
            if (visitEventType === ON_STREAM_ID_CREATED) {
                const { streamId, userId: emittedUserId } = visitEventPayload;
                const receivedBy =
                    userId ||
                    store.get('bloomIfAI_id') ||
                    store.get('userSession')?.id ||
                    store.get('userId');

                // Get CURRENT visitId dynamically (handles new_session_details updates)
                const currentVisitId = sessionStorage.getItem('visitId') || store.get('visitId');

                // console.log('🔵 [Socket] RECEIVED on_stream_id_created via VISIT channel:', {
                //     streamId,
                //     userId: emittedUserId,
                //     receivedBy,
                //     visitId: currentVisitId,
                //     closureVisitId: visitId,  // Compare with closure value
                //     timestamp: new Date().toISOString(),
                //     rawData: data,
                // });

                // PRODUCTION FIX: Store the mapping with validation
                // This can be accessed by Subscribers/ClassRoomSubscribers for caption userId resolution
                if (streamId && emittedUserId && emittedUserId !== 'undefined' && emittedUserId !== receivedBy) {
                    const existingMappings = JSON.parse(
                        sessionStorage.getItem('streamIdMappings') || '{}'
                    );
                    existingMappings[streamId] = emittedUserId;
                    sessionStorage.setItem('streamIdMappings', JSON.stringify(existingMappings));

                    logSessionEvent('info', 'STREAM_ID_MAPPING_RECEIVED', {
                        streamId,
                        userId: emittedUserId,
                        totalMappings: Object.keys(existingMappings).length,
                        visitId: currentVisitId,
                        receivedBy,
                    });
                } else {
                    console.error(
                        '❌ [Socket] Invalid streamId data received - skipping storage:',
                        {
                            streamId,
                            userId: emittedUserId,
                            isValidStreamId: !!streamId,
                            isValidUserId: !!(
                                emittedUserId &&
                                emittedUserId !== 'undefined' &&
                                emittedUserId !== receivedBy
                            ),
                            rawData: data,
                            parsedType: visitEventType,
                            parsedPayload: visitEventPayload,
                        }
                    );
                }
            }

            // Handle live captions received from other participants
            // CRITICAL: Uses dynamic visitId to handle session context changes
            if (visitEventType === ON_LIVE_CAPTION) {
                const captionData = visitEventPayload;
                const receivedBy =
                    userId ||
                    store.get('bloomIfAI_id') ||
                    store.get('userSession')?.id ||
                    store.get('userId');

                // Get CURRENT visitId dynamically (handles new_session_details updates)
                const currentVisitId = sessionStorage.getItem('visitId') || store.get('visitId');

                // PRODUCTION FIX: Resolve userId if it's not in studentDetails (handles rejoin with new userId)
                // Check if userId exists in current session data
                const studentDetails = store.get('studentDetails') || store.get('visitInformation');
                const allUsers = [
                    ...(studentDetails?.sessionUsers || []),
                    ...(studentDetails?.externalUsersDetails || []),
                ];
                const userExists = allUsers.some((u) => u.userId === captionData.userId);

                // If userId not found in current session, try to resolve via identity map
                let resolvedUserId = captionData.userId;
                if (!userExists && captionData.userId) {
                    try {
                        const identityMapRaw = sessionStorage.getItem('userIdentityMap');
                        if (identityMapRaw) {
                            const identityMap = JSON.parse(identityMapRaw);
                            // Check if this userId is in identity map
                            const identityEntry = identityMap[captionData.userId];
                            if (identityEntry?.names) {
                                // Try to find a user in current session with any of these names
                                const names = Array.isArray(identityEntry.names)
                                    ? identityEntry.names
                                    : [identityEntry.names];
                                for (const name of names) {
                                    const matchedUser = allUsers.find((u) => u.name === name);
                                    if (matchedUser?.userId) {
                                        resolvedUserId = matchedUser.userId;
                                        // console.log('🗺️ [Caption] Resolved userId via identity map:', {
                                        //     originalUserId: captionData.userId,
                                        //     resolvedUserId: resolvedUserId,
                                        //     name: name,
                                        //     reason: 'userId_not_in_current_session'
                                        // });
                                        break;
                                    }
                                }
                            }
                        }
                    } catch (e) {
                        console.error('❌ [Caption] Error resolving userId via identity map:', e);
                    }
                }

                // Update caption data with resolved userId
                const resolvedCaptionData = { ...captionData, userId: resolvedUserId };

                // console.log('📝 [Socket] RECEIVED on_live_caption via VISIT channel:', {
                //     caption: captionData.caption,
                //     streamId: captionData.streamId,
                //     originalUserId: captionData.userId,
                //     resolvedUserId: resolvedUserId,
                //     userIdResolved: resolvedUserId !== captionData.userId,
                //     isFinal: captionData.isFinal,
                //     receivedBy,
                //     visitId: currentVisitId,
                //     closureVisitId: visitId,  // Compare with closure value
                //     timestamp: new Date().toISOString(),
                // });

                // Dispatch to store for display in UI
                // Video components can listen to this action to show captions
                dispatch({
                    type: 'LIVE_CAPTION_RECEIVED',
                    payload: resolvedCaptionData,
                });

                logSessionEvent('info', 'LIVE_CAPTION_RECEIVED', {
                    streamId: captionData.streamId,
                    userId: resolvedUserId,
                    isFinal: captionData.isFinal,
                    captionLength: captionData.caption?.length || 0,
                    visitId: currentVisitId,
                    receivedBy,
                });
            }

            if (data.type === ON_MESSAGE) {
                if (data.response.role === userType) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS,
                            data.response.message
                        )
                    );
                    data?.response?.message?.messageType !== 2 &&
                        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                } else {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE,
                            data.response.message
                        )
                    );
                    data?.response?.message?.messageType !== 2 &&
                        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                }
            }
            if (data.type === ON_WHITEBOARD_MESSAGE) {
                const whiteboardMessage = data?.response?.message?.message;
                if (whiteboardMessage) {
                    saveWhiteboardDataForSession(visitId, whiteboardMessage);
                }
                dispatch({
                    type: ACTION_TYPES.WHITE_BOARD_DRAW,
                    payload: {
                        visitId: visitId,
                        senderUserId: data.response.message.senderUserId,
                        whiteBoardDrawList: data.response.message.message,
                    },
                });
            }
            if (data.type === ON_CHAT_MESSAGE) {
                if (data.response.role === userType) {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_SUCESSS,
                            data.response.message
                        )
                    );
                } else {
                    dispatch(
                        customeAction(
                            ACTION_TYPES.PHYSICIAN.ON_MESSAGE_RECEVICE,
                            data.response.message
                        )
                    );
                    data?.response?.message?.messageType !== 2 &&
                        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_ADD, 1));
                }
            }
        });

        /**
         * socket disconnected
         */
        socketChat.on(SOCKET_DISCONNECTED, (data) => {
            myLog('--------------_>>>>>>   socket_disconnected Chat', data);
            isChatConnect = false;
        });
        /**
         * connect error
         */
        socketChat.on(CONNECT_ERROR, (data) => {
            dispatch(socketServerDownProblem(true));
            myLog('--------------_>>>>>>   error Chat', data);
        });

        /**
         * connect timeout
         */
        socketChat.on(CONNECT_TIMEOUT, (data) => {
            myLog('--------------_>>>>>>   connect_timeout Chat', data);
        });
        /**
         * Wrong Information
         */
        socketChat.on(WRONG_INFORMATION, (data) => {
            dispatch(socketServerDownProblem(true));
            myLog('--------------_>>>>>>   WRONG INFORMATION web', data);
        });
    };

/**
 * Stop socketWeb conection
 */
export const stopWebSocketConnect = () =>
    function () {
        socketWeb.close();
    };

/**
 * Stop socketChat conection
 */
export const stopChatSocketConnect = () =>
    function () {
        if (socketChat && typeof socketChat.close === 'function') {
            socketChat.close();
        }
        isChatConnect = false;
    };

export const stopCustomChatSocketConnect = () =>
    function () {
        if (socketCustomChat && typeof socketCustomChat.close === 'function') {
            socketCustomChat.close();
        }
    };

export const checkWebConnect = () => {
    if (typeof socketWeb === 'undefined' && typeof store.get('userSession') === 'object') {
        const { id } = store.get('userSession');
        const role = store.get('userSession').role === Tutor ? Doctor : Patient;
        stores.dispatch(startWebSocketConnect(id, role));
    }
};

export const adminCheckWebConnect = () => {
    if (typeof socketWeb === 'undefined' && typeof store.get('insAdminSession') === 'object') {
        const { id, role } = store.get('insAdminSession');
        stores.dispatch(adminStartWebSocketConnect(id, role));
    }
};

export const onWhiteBoardDraw = (input, callBack) => () => {
    if (input) {
        customeAction(ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED, {});
        socketChat.emit(EMIT_ON__WHITEBOARD_SEND_MESSAGE, input);
        const message = {
            textMessage: input.textMessage,
        };
        callBack(message);
    }
};

export const onWhiteBoardOpen = (input, callBack) => () => {
    if (input) {
        customeAction(ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED, {});
        socketChat.emit(EMIT_ON__WHITEBOARD_OPEN, input);
        const message = {
            textMessage: input.textMessage,
        };
        callBack(message);
    }
};

/**
 * Emits chat socket actions while sending message
 * @param {String} input
 * @param {Function} callBack
 */
export const onSendMessage = (input, callBack) => () => {
    myLog(input);
    if (input) {
        customeAction(ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED, {});
        socketChat.emit(EMIT_ON_SEND_MESSAGE, input);
        callBack(true);
    }
};

export const onCustomSendMessage = (input, callBack) => () => {
    if (input) {
        customeAction(ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED, {});
        socketCustomChat.emit(EMIT_ON_CUSTOM_SEND_MESSAGE, input);
        const message = {
            textMessage: input.textMessage,
            fileId: input.fileId,
            havingImage: input.havingImage,
            userBfId: input.userBfId,
            blmToken: input.blmToken,
        };
        callBack(message);
    }
};

export const onCustomReadMessage = (input) => () => {
    if (input) {
        customeAction(ACTION_TYPES.PHYSICIAN.ON_MESSAGE_SEND_CLICKED, {});
        socketCustomChat.emit(ON_CHAT_MESSAGE_READ, input);
    }
};

export const onChatOpened = (input) => () => {
    if (input) {
        socketCustomChat.emit(ON_CHAT_OPENED, input);
    }
};

/**
 * Emits chat socket actions while sending message
 * @param {String} input
 * @param {Function} callBack
 */
export const onPatientEndCall = (visitId, callBack) => (dispatch) => {
    clearWhiteboardDataForSession(visitId);
    socketChat.emit(ON_PATIENT_CALL_END, visitId);
    callBack(true);
    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_END_SUCESSS, {}));
};

/**
 * Emits chat socket action while mute video
 * @param {String} input
 * @param {Function} callBack
 */
export const onMuteVideo = (input, callBack) => () => {
    if (isChatConnect) {
        socketChat.emit(input ? ON_PHYSICIAN_CAMERA_ON : ON_PHYSICIAN_CAMERA_OFF, null);
        callBack(true);
    } else {
        callBack(false);
    }
};

/**
 * Cleares unreaded message count
 */
export const clearUnreadCount = () => (dispatch) => {
    dispatch(customeAction(ACTION_TYPES.PHYSICIAN.UNREAD_COUNT_CLEAR, 0));
};

/**
 * Connects to video call
 * @param {Object} response
 */
export const connectVideoCall = (response) => {
    myLog('--------------_>>>>>>   connectVideoCall ', response);
    return (dispatch) => {
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.VIDEO_CALL_CONNECTED_SUCESS, response));
        dispatch({
            type: ACTION_TYPES.PATIENT.PHYSICIAN_CAMERA_ON,
            payload: true,
        });
        dispatch({
            type: ACTION_TYPES.PHYSICIAN.RECORDING_CALL,
            payload: {
                isRecording: response.recording,
            },
        });
        dispatch({
            type: ACTION_TYPES.PHYSICIAN.userIds,
            payload: {
                patientUserId: response.patientUserId,
                doctorUserId: response.doctorUserId,
            },
        });
    };
};

/**
 * Alert sound to denote physician entered exam room
 * @param {*} status
 */
export const soundAlert = (status) => {
    if (status === 1) {
        audio.play();
    } else if (status === 0) {
        audio.pause();
        audio.currentTime = 0;
    }
};

/**
 * Alert popup with sound when physician enters exam room
 * @param {*} response
 */
export const pushNotification = (response) => {
    myLog('--------------_>>>>>>   pushNotification ', response);
    return (dispatch) => {
        // soundAlert(1);
        dispatch(customeAction(ACTION_TYPES.PHYSICIAN.PHYSICIAN_ISONLINE, response));
    };
};

/**
 * custom action for dispatch
 * @param {String} action
 * @param {Object} data
 */
export const customeAction = (action, data) => ({
    type: action,
    payload: data,
});

/**
 * Emits typing indicator when a message is being typed
 * @param {Object} input
 */
export const onTyping = (input) => () => {
    if (input) {
        customeAction(ACTION_TYPES.TYPING_INDICATOR, {});
        socketCustomChat.emit(ON_TYPING, input);
    }
};

export const onReadMessage = (input) => () => {
    if (input) {
        customeAction(ACTION_TYPES.MESSAGE_READ, {});
        socketCustomChat.emit(MESSAGE_READ, input);
    }
};

// Add event listeners
// window.addEventListener("beforeunload", function (event) {
//   const visitId = sessionStorage.getItem("visitId");
//   const userId = sessionStorage.getItem("userId");

//   if (visitId && userId) {
//     Client.disableOwnerOnVideoCall(visitId, userId)
//       .then((response) => {
//         myLog("API call successful:", response);
//       })
//       .catch((error) => {
//         myLog("API call failed:", error);
//       });
//   }
// });

// window.addEventListener("popstate", function (event) {
//   const visitId = sessionStorage.getItem("visitId");
//   const userId = sessionStorage.getItem("userId");

//   if (visitId && userId) {
//     Client.disableOwnerOnVideoCall(visitId, userId)
//       .then((response) => {
//         myLog("API call successful:", response);
//       })
//       .catch((error) => {
//         myLog("API call failed:", error);
//       });
//   }
// });

export const emitLiveCaption = (userInfo) => {
    if (!socketChat) {
        logSessionEvent('error', 'LIVE_CAPTION_SOCKET_NOT_INITIALIZED', {
            status: 'error',
        });
        return;
    }

    if (!socketChat.connected) {
        logSessionEvent('error', 'LIVE_CAPTION_SOCKET_NOT_CONNECTED', {
            status: 'error',
        });
        return;
    }

    try {
        if (userInfo.isFinal) {
            // CRITICAL: Include visitId so server knows which room to broadcast to
            const visitId = sessionStorage.getItem('visitId') || store.get('visitId');
            const resolvedUserId = getResolvedSocketUserId(userInfo.userId);
            const enrichedData = {
                ...userInfo,
                userId: resolvedUserId,
                visitId, // Add visitId for room-based broadcasting
            };

            socketChat.emit(EMIT_LIVE_CAPTION, enrichedData);
            logSessionEvent('info', 'LIVE_CAPTION_EMITTED', {
                status: 'success',
                visitId,
                userId: resolvedUserId,
            });
        }
    } catch (error) {
        logSessionEvent('error', 'LIVE_CAPTION_EMIT_ERROR', {
            status: 'error',
            error: error && error.message ? error.message : error,
        });
    }
};

export const emitStreamId = (data) => {
    if (socketChat && socketChat.connected) {
        // CRITICAL: Include visitId so server knows which room to broadcast to
        const visitId = sessionStorage.getItem('visitId') || store.get('visitId');
        const urlParams = new URLSearchParams(window.location.search);
        const urlUserId = urlParams.get('userId');
        const createdByUserId = urlParams.get('createdByUserId');
        const sessionType = (urlParams.get('sessionType') || '').toLowerCase();
        const isSocketAuthSession = !!urlParams.get('socketAuthentication');
        const isGroupLikeSocketAuthSession =
            isSocketAuthSession &&
            (sessionType.includes('group') ||
                sessionType.includes('class') ||
                sessionType.includes('conference'));

        if (
            isGroupLikeSocketAuthSession &&
            !data?.isPublisherStream &&
            createdByUserId &&
            data?.userId === createdByUserId
        ) {
            logSessionEvent('warn', 'STREAM_ID_EMIT_SKIPPED_CREATED_BY_FALLBACK', {
                status: 'skipped',
                visitId,
                streamId: data?.streamId,
                userId: data?.userId,
            });
            return;
        }

        const streamOwnerUserId =
            isSocketAuthSession && data?.isPublisherStream && urlUserId
                ? urlUserId
                : data?.userId;
        const userId =
            store.get('bloomIfAI_id') || store.get('userSession')?.id || store.get('userId');
        const enrichedData = {
            ...data,
            userId: streamOwnerUserId,
            visitId, // Add visitId for room-based broadcasting
        };

        // console.log('🚀 [EMIT] Emitting streamId via socket:', {
        //     emittedBy: userId,
        //     streamId: data?.streamId,
        //     targetUserId: data?.userId,
        //     visitId: visitId,
        //     socketConnected: socketChat.connected,
        //     socketId: socketChat?.id,
        //     eventName: EMIT_STREAM_ID_CREATED,
        //     timestamp: new Date().toISOString(),
        //     fullData: enrichedData
        // });

        socketChat.emit(EMIT_STREAM_ID_CREATED, enrichedData);

        // console.log('✅ [EMIT] Socket emission completed - waiting for server broadcast');

        logSessionEvent('info', 'STREAM_ID_EMITTED', {
            status: 'success',
            visitId,
            streamId: data?.streamId,
            userId: streamOwnerUserId,
            emittedBy: userId,
        });
    } else {
        console.error('❌ [EMIT] Cannot emit - socket not connected:', {
            hasSocket: !!socketChat,
            isConnected: socketChat?.connected,
            userId: store.get('bloomIfAI_id') || store.get('userSession')?.id,
        });

        logSessionEvent('error', 'STREAM_ID_EMIT_FAILED_SOCKET_DISCONNECTED', {
            status: 'error',
        });
    }
};
